/**
 * Created by jtrav on 4/28/2019.
 */
import React,{ Component } from "react";
import { Link } from "react-router-dom";
import {connect} from "react-redux";
import classnames from 'classnames';
import { getConnectionProxies} from "../../../actions/actionConnectionProxies";
import { Row, Col, Table, Card, CardBody, CardHeader, Button, TabContent, TabPane, Nav, NavItem, NavLink} from "reactstrap";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import moment from "moment";
import ReactJson from 'react-json-view';
import iconNo from "../../../../assets/images/icon_no.svg";
import iconYes from "../../../../assets/images/icon_yes.svg";

const routes = [
    {name: "Home", path:"/userdashboard", isActive: false},
    {name: "ConnectionProxy", path:"/connection_proxies", isActive: false},
    {name: "ViewConnectionProxy", path:"/viewconnection_proxy", isActive: true},
];

class ViewConnectionProxy extends Component{
    constructor(props){
        super(props);
        this.state = {
            currentConnectionProxy: null,
            activeTab: 0
        };
    }
  
    componentDidMount(){
        this.props.getConnectionProxies();
    }
      
    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.connection_proxies.length > 0){        	
            let currentConnectionProxy = nextProps.connection_proxies.find(connection_proxy => connection_proxy.connection_proxy_id === this.props.match.params.id);
            this.setState({currentConnectionProxy: currentConnectionProxy});
        }
    }


    render(){
        const {currentConnectionProxy} = this.state;
        return (
            <div className="profile-page"> 
                <BreadCrumbCompo routes={routes}/>    
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                               <strong>View Connection Proxy</strong>
                                {currentConnectionProxy ? <Link className="pull-right" to={{ pathname: `/update_connection_proxy/${currentConnectionProxy.connection_proxy_id}`}}>
                                    <Button className = "reset-btn" size="sm" color="primary"> Edit </Button> </Link> :" "}
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">
                                        <div className="profile-table">
                                            {currentConnectionProxy?
                                                <Table >
                                                    <tbody>
                                                        <tr><td><h4>ID</h4></td><td>{currentConnectionProxy.connection_proxy_id ? currentConnectionProxy.connection_proxy_id : "-"}</td></tr>
                                                        <tr><td><h4>Type</h4></td><td>{currentConnectionProxy.connection_proxy_type ? currentConnectionProxy.connection_proxy_type : "-"}</td></tr>
                                                        <tr><td><h4>Auth Token</h4></td><td>{currentConnectionProxy.auth_token ? currentConnectionProxy.auth_token : "-"}</td></tr>
                                                        <tr><td><h4>Server Address</h4></td><td>{currentConnectionProxy.server_address? currentConnectionProxy.server_address: "-"}</td></tr>
                                                        <tr><td><h4>Server Port</h4></td><td>{currentConnectionProxy.server_port ? currentConnectionProxy.server_port : "-"}</td></tr>
                                                        <tr><td><h4>Zone</h4></td><td>{currentConnectionProxy.zone_name ? currentConnectionProxy.zone_name: "-"}</td></tr>
                                                    </tbody>
                                                </Table> :" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );}
}

ViewConnectionProxy.propTypes = {
    getConnectionProxies: Proptypes.func.isRequired,
    connection_proxies: Proptypes.array,
    match: Proptypes.object,
};

export default connect(state => 
    ({
        connection_proxies: state.connection_proxies.connection_proxies || [],
    }),
dispatch => 
    ({
        getConnectionProxies: () => dispatch(getConnectionProxies()),
    }))(ViewConnectionProxy);